module.exports = __webpack_public_path__ + "static/media/forsideBanner.59a5bde6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/forsideBanner.jpg
// module id = 357
// module chunks = 0